module.exports = __webpack_public_path__ + "static/media/mashroom.319ad575.png";